import { render, staticRenderFns } from "./ViewSet.vue?vue&type=template&id=15a4dcb0&scoped=true"
import script from "./ViewSet.vue?vue&type=script&lang=js"
export * from "./ViewSet.vue?vue&type=script&lang=js"
import style0 from "./ViewSet.vue?vue&type=style&index=0&id=15a4dcb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4dcb0",
  null
  
)

export default component.exports